export default __webpack_public_path__ + "locales/si/Translations.json?hash=b083275c0c6298cafcc4cf7cc9806f9c";